import type { SidebarTabKey } from '../../work-queue/tasks/taskSidebarTabs';
import { useTaskFlowParam } from '../../work-queue/tasks/useTaskFlowParam';

export const CASE_ACTION_FLOWS = ['refinement', 'retention'] as const;
export type CaseActionFlow = (typeof CASE_ACTION_FLOWS)[number];

const ACTIONS_TAB: SidebarTabKey = 'actions';

// A reload mid-wizard reopens the Actions tab, since the wizard runs inside it.
export function useInitialSidebarTab(defaultTab: SidebarTabKey): SidebarTabKey {
    const { flow } = useTaskFlowParam(CASE_ACTION_FLOWS);
    return flow ? ACTIONS_TAB : defaultTab;
}
